import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';


export default function Line(props) {
    const { color, width, className } = props;

    return (
        <hr
            className={classNames(
                'my-10',
                color && `text-${color}`,
                width && `border-b-${width}`,
                width && color && 'border-certego-blue',
                className,
            )}
        />
    );
}

Line.defaultProps = {
    color: null,
    className: null,
    width: null,
};

Line.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.number,
};
